
export const Environment = {

  LIMITE_DE_LINHAS: 8,

  LIMITE_DE_LINHAS1: 8,

  LIMITE_DE_LINHASSMALL: 8,

  LIMITE_DE_CADASTRO: 8,

  INPUT_DE_BUSCA: 'Pesquisar...',

  LISTAGEM_VAZIA: 'Nenhum registro encontrado.',

  URL_BASE: window.env.REACT_APP_URL_BASE,

  URL_BASE_LOGIN: window.env.REACT_APP_URL_BASE_LOGIN,

  URL_IDPARCEIRO: window.env.REACT_APP_IDPARCEIRO,

  URL_IDPLANODECONTAS: window.env.REACT_APP_IDPLANODECONTAS,

  IDVENDAAVISTA: window.env.REACT_APP_IDOVENDAAVISTA,

  URL_IMGUSUARIOS: window.env.REACT_APP_URL_IMGUSUARIOS,

  URL_PDFNFE: window.env.REACT_APP_URL_PDFNFE,

  URL_IDCONTA: window.env.REACT_APP_IDCONTA,

  IDVENDAPRAZO: window.env.REACT_APP_IDVENDAPRAZO,
  IDPIX: window.env.REACT_APP_IDPIX,
  IDCARTAO: window.env.REACT_APP_IDCARTAO,
  IDORCAMENTO: window.env.REACT_APP_IDORCAMENTO,

  URL_IMGPRODUTOS: window.env.REACT_APP_URL_IMGPRODUTOS,

  COR_RELATORIOS: '#40481E',

  COR_RELATORIOS_TEXTO: '#000000'

};



